t = require('views/internal/teacup-with-helpers')('avatar_change')

module.exports = ->
  t.mustacheBlock 'uploadedAvatarHash', ->
    t.a { class: 'avatar-option js-use-uploaded-avatar ' + t.mustacheBlock('avatarSource_upload', (-> 'active')), href: '#' }, ->
      t.img '.pic', { src: t.mustacheVar('__avatarDomain') + '/' + t.mustacheVar('uploadedAvatarHash') + '/50.png' }
      t.span '.text', ->
        t.format 'uploaded-picture'
        t.icon 'check'

    t.hr()

  t.div '.js-grav.hide', ->
    t.a { class: 'avatar-option js-use-gravatar ' + t.mustacheBlock('avatarSource_gravatar', (-> 'active')), href: '#' }, ->
      t.img '.pic', { src: 'https://secure.gravatar.com/avatar/' + t.mustacheVar('gravatarHash') + '.png?s=50&r=PG&d=404' }
      t.span '.text', ->
        t.format 'gravatar'
        t.icon 'check'

    t.hr()

  t.a { class: 'avatar-option js-no-avatar ' + t.mustacheBlock('avatarSource_none', (-> 'active')), href: '#' }, ->
    t.span '.pic.member', ->
      t.span '.member-initials', ->
        t.text t.mustacheVar('initials')
    t.span '.text', ->
      t.format 'initials-no-avatar'
      t.icon 'check'

  t.hr()

  t.mustacheBlock 'canTakePhoto', ->
    t.a '.button-link.js-take-photo', { href: '#' }, ->
      t.icon 'camera', 'take-photo-with-camera'

    t.hr()

  t.p '.error.hide.js-error'

  t.div '.uploader', ->
    t.form '.realfile', { action: '/1/member/' + t.mustacheVar('id') + '/avatar', method: 'post', enctype: 'multipart/form-data' }, ->
      t.input { type: 'hidden', name: 'token', value: '' }
      t.input { type: 'hidden', name: 'format', value: 'http' }
      t.input '.js-upload-avatar', { type: 'file', name: 'file', style: 'margin-bottom: 0;', tabindex: '-1', accept: 'image/*;capture=camera' }
    t.a '.button-link.fakefile', ->
      t.mustacheBlock 'uploadedAvatarHash', ->
        t.icon 'attachment', 'upload-a-new-picture'
      t.mustacheBlockInverted 'uploadedAvatarHash', ->
        t.icon 'attachment', 'upload-a-picture'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/avatar_change.coffee